import React from 'react';
import TimedealProductCard from './TimedealProductCard';
import { TimedealExposureWidgetItem } from '../../../../../../types/widget';
import Slider from '../../../../../../components/utils/Slider/Slider';
import { TimedealSwipeWrapperStyle } from './style';

interface WidgetPreviewTimedealSwipeProps {
  exposureWidgetItemList: TimedealExposureWidgetItem[];
}
const WidgetPreviewTimedealSwipe = (props: WidgetPreviewTimedealSwipeProps): JSX.Element => {
  const { exposureWidgetItemList } = props;

  return (
    <TimedealSwipeWrapperStyle>
      <Slider
        list={exposureWidgetItemList}
        arrows={false}
        infinite={false}
        item={(widgetItem: TimedealExposureWidgetItem) => <TimedealProductCard widgetItem={widgetItem} />}
      />
    </TimedealSwipeWrapperStyle>
  );
};

export default WidgetPreviewTimedealSwipe;
